<template>
  <div class="address-form">
    <div
      class="h2 margin-bottom-xxs h5"
      data-testid="address-form-title"
    >
      {{ firstSectionTitle }}
    </div>
    <p class="margin-bottom-25">
      All fields required.
    </p>
    <div class="margin-bottom-25">
      <InputText
        v-model="fullName"
        name="fullName"
        label="Full name"
        rule="lastName: first and "
      />
    </div>
    <div class="margin-bottom-25 ">
      <InputText
        v-model="address"
        name="address"
        label="Address"
        rule="addressLine1"
      />
    </div>
    <div class="margin-bottom-9">
      <InputText
        v-model="city"
        name="city"
        label="City"
        rule="city"
      />
    </div>
    <div class="grid-x margin-bottom-17">
      <div
        class="small-6 cell padding-right-xs"
      >
        <Dropdown
          v-model="state"
          name="state"
          label="State"
          :options="STATES"
          validation-message="Select a state"
          required
        />
      </div>
      <div class="small-6 cell">
        <InputText
          v-model="zipCode"
          name="zipCode"
          label="Zip Code"
          rule="zipCode"
        />
      </div>
    </div>
    <InputText
      v-model="email"
      name="email"
      label="E-mail"
      rule="email"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import Dropdown from '@atomic-ui/dropdown';
import InputText from '@atomic-ui/inputText';
import { useBrand } from '@composables/useBrand';
import { STATES } from '../constants';

const { isMcom } = useBrand();

const firstSectionTitle = isMcom
  ? '2. Provide your address'
  : 'PROVIDE YOUR ADDRESS';

const fullName = ref('');
const address = ref('');
const city = ref('');
const state = ref('');
const zipCode = ref('');
const email = ref('');

</script>

<style lang="scss" scoped>
.margin-bottom-25 {
  margin-bottom: rem-calc(25);
}

.margin-bottom-9 {
  margin-bottom: rem-calc(9);
}

.margin-bottom-17 {
  margin-bottom: rem-calc(17);
}
</style>
